module.exports = __webpack_public_path__ + "static/media/mock-uc-product.c0bc6cd5.jpg";